
<template>
    <v-sheet height="100%" class="d-flex flex-column" style="overflow: hidden">
        <v-form v-model="isValid" class="pa-16" style="height: 100%; overflow: auto">
            <v-text-field label="아이디" v-model="inputs.username" :rules="rules.username" outlined dense />
            <v-password-field label="비밀번호" v-model="inputs.password" :rules="rules.password" outlined dense />
            <v-password-confirm-field label="비밀번호확인" :password="inputs.password" outlined dense />

            <v-text-field label="이름" v-model="inputs.name" :rules="rules[PERSON.value]?.name" outlined dense />
            <v-text-field label="생년월일" v-model="inputs.bornAt" type="date" max="2999-12-31" :rules="rules[PERSON.value]?.bornAt" outlined dense />
            <v-select label="성별" v-model="inputs.gender" :items="genders" :rules="rules[PERSON.value]?.gender" outlined dense />

            <!-- 번호인증 -->
            <user-contact-certification v-model="inputs.phone" outlined dense :btnAttrs="{ color: 'primary', width: 100, height: 50, className: 'mt-n8' }" />

            <!-- 약관동의 -->
            <terms-of-agreements-short v-model="inputs._terms" @isValid="(isValid) => (isTermsValid = isValid)" />
        </v-form>
        <v-btn :disabled="!isValid" @click="join" x-large block tile class="primary white--text">회원가입</v-btn>
    </v-sheet>
</template>

<script>
import api from "@/api";
import Axios from "axios";
import CryptoAES from "@/plugins/crypto-aes";
import { attrs_input, GENDERS, rules, USER_TYPES } from "@/assets/variables";

import TermsDialog from "@/components/client/join/terms-dialog.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import VPasswordConfirmField from "@/components/plugins/vuetify/v-password-confirm-field.vue";
import UserContactCertification from "@/components/dumb/user-contact-certification.vue";
import TermsOfAgreementsShort from "../../terms-of-agreements-short.vue";
import { mapActions } from "vuex";

const { PERSON } = USER_TYPES;
const genders = Object.values(GENDERS);

const initInputs = () => ({
    _terms: [],

    username: null,
    password: null,

    name: null,
    phone: null,
    bornAt: null,
    gender: null,
    code: PERSON.value,
});

export default {
    components: {
        TermsDialog,
        VPasswordField,
        VPasswordConfirmField,
        UserContactCertification,
        TermsOfAgreementsShort,
    },
    props: {
        isDialog: { type: Boolean, default: false },
    },
    data: () => ({
        rules,
        PERSON,
        genders,
        attrs_input,

        inputs: initInputs(),
        isValid: true,
        isTermsValid: undefined,
    }),
    computed: {
        accessToken() {
            return this.$route.query.accessToken;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions(["login"]),

        async init() {
            if (this.accessToken) {
                try {
                    const { user = {} } = (await Axios.get("/api/v1/me", { headers: { Authorization: `Bearer ${this.accessToken}` } }))?.data || {};
                    let { _id, bornAt, gender } = user;
                    bornAt = bornAt?.toDate?.() || bornAt;
                    this.inputs = { ...initInputs(), _id, bornAt, gender };
                } catch {
                    if (!this.isDialog) this.$router.push("/join/intro");
                }
            } else {
                this.inputs = initInputs();
            }
        },

        async join() {
            if (!this.validates()) return;
            const inputs = {
                ...this.inputs,
                password: CryptoAES.encrypt(this.inputs.password),
            };
            await api.v1.users.post(inputs);

            if (!this.isDialog) this.$router.push("/join/complete");
            else {
                let { username, password } = this.inputs;
                await this.login({ username, password });
                this.$emit("forward");
            }
        },

        validates() {
            try {
                switch (this.isTermsValid) {
                    case undefined:
                        throw new Error("이용약관을 확인해주세요");
                    case false:
                        throw new Error("필수 이용약관에 모두 동의해주세요");
                    default:
                        break;
                }
            } catch (error) {
                alert(error.message);
                return false;
            }
            return true;
        },
    },
};
</script>
